import { render, staticRenderFns } from "./keno.vue?vue&type=template&id=22bc9467&"
import script from "./keno.vue?vue&type=script&lang=js&"
export * from "./keno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports